import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React, { CSSProperties } from 'react';
import { BsArrowReturnRight } from 'react-icons/bs';
import { Input } from 'reactstrap';
import { PresentationObject } from '../../../../types/constants';
import { IInfoGoHeaderOrg } from '../../../../types/infogo';
import { AddIcon, CancelIcon, CheckMarkIcon, DeleteIcon, DnDIcon, EditIcon, TreeCollapseIcon, TreeExpandIcon } from '../../../common/icons';
import Spacer from '../../../common/spacer';
import OmsToolTip from '../../../common/tooltip/tooltip';
import './header-orgs.scss';
import useAuth from '../../../../hook/useAuth';
import { useFrench } from '../../../french/french-context';
import Button from '../../../common/button';

type HeaderOrgItemProps = {
    id: any;
    shareCloned: boolean;
    childCount?: number;
    clone?: boolean;
    collapsed?: boolean;
    depth: number;
    indentationWidth: number;
    itemData: IInfoGoHeaderOrg;
    suppressed: boolean;
    isDirty?: boolean;
    onSuppressCheck: (event: any) => void
    onCollapse?(): void;
    onEditHeader?(): void;
    onDeleteHeader?(): void;
    onAddHeader?(): void;
}

const HeaderOrgItem = (props: HeaderOrgItemProps) => {
    const { id, shareCloned, childCount, itemData, suppressed, onSuppressCheck, collapsed, isDirty, depth, clone, indentationWidth, onCollapse, onEditHeader, onDeleteHeader, onAddHeader } = props
    const { isFrenchTranslator } = useAuth()
    const [frenchState] = useFrench()
    const { attributes, listeners, setDraggableNodeRef, setDroppableNodeRef, isDragging, transform, transition } = useSortable({ id });

    const style: CSSProperties = {
        transform: CSS.Translate.toString(transform),
        transition
    }

    const isHeader = () => {
        return itemData.typeName===PresentationObject.BIZ_GROUP
    }

    const handleEditHeader = (event: any) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            event.stopPropagation()
            onEditHeader && onEditHeader()
        }
    }

    const handleDeleteHeader = (event: any) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            event.stopPropagation()
            onDeleteHeader && onDeleteHeader()
        }
    }

    const handleAddHeader = (event: any) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            event.stopPropagation()
            onAddHeader && onAddHeader()
        }
    }

    return (
        <li className={`header-wrapper ${isDragging ? 'ghost' : ''} ${clone ? 'clone': ''}`}
            ref={setDroppableNodeRef}
            style={{'--spacing': `${indentationWidth * depth}px`} as React.CSSProperties}>

            <div className={`focus-ring header-tree-item ${!isFrenchTranslator ? 'cursorMove' :'cursorInherit'}`} {...attributes} {...listeners}
                tabIndex={0}
                ref={setDraggableNodeRef}
                style={style}>
                <div style={{ marginTop: '-2px', paddingRight: '1rem' }}><DnDIcon /></div>
                   {onCollapse
                        ? <a onClick={onCollapse} aria-expanded={!collapsed} style={{ paddingLeft: '0px', cursor: 'pointer' }}>
                            {!collapsed ? <TreeCollapseIcon /> : <TreeExpandIcon />}
                        </a>
                        : <BsArrowReturnRight />
                    }
                <div className="header-text" style={{fontWeight: isHeader()?'bold':'normal', fontStyle: isHeader()?'italic':'normal'}}>
                    {!isHeader()
                        ? isDragging && !isFrenchTranslator
                            ?  <span style={{pointerEvents: "none"}}>{itemData.name}</span>
                            :  <OmsToolTip id={`header_${itemData.id}_tooltip`} orgId={Number(itemData.id)}>
                                    <span style={{pointerEvents: "none"}}>{itemData.name}</span>
                                </OmsToolTip>
                        : <div>
                            <span style={{verticalAlign: 'middle'}}>{itemData.name}</span>
                            <Spacer width="2rem"/>
                            {!isDirty && !shareCloned  && <>
                                {((!isFrenchTranslator || frenchState.isFrenchChecked)) && <Button type="button" className="header-action focus-ring" aria-label="Edit Header" color="secondary" size="sm" title="Edit Header" onClick={onEditHeader} onKeyDown={handleEditHeader}>
                                    <EditIcon className="edit-pencil" />
                                </Button>
                                }
                                {!isFrenchTranslator &&
                                    <>
                                        <Button type="button" className="header-action focus-ring" aria-label="Delete Header" color="secondary" size="sm" title="Delete Header" onClick={onDeleteHeader} onKeyDown={handleDeleteHeader}>
                                            <DeleteIcon color="var(--bs-body-color)" />
                                        </Button>
                                        <Button type="button" className="header-action focus-ring" aria-label="Add Child Header" color="secondary" size="sm" title="Add Child Header" onClick={onAddHeader} onKeyDown={handleAddHeader}>
                                            <AddIcon color="var(--bs-body-color)" />
                                        </Button>
                                    </>
                                }

                            </>}
                        </div>
                    }
                </div>
                {clone && childCount && childCount > 1 ? (
                    <span className="header-count">{childCount}</span>
                ) : null}

                {!isHeader() &&
                    <div className="header-suppress">
                       {!isFrenchTranslator &&  <Input type="checkbox"
                            aria-label="suppress"
                            checked={suppressed}
                            onChange={onSuppressCheck}
                        />}
                        {isFrenchTranslator && <div>{suppressed? <CheckMarkIcon></CheckMarkIcon>: <CancelIcon></CancelIcon>}</div>}
                    </div>
                }
            </div>
        </li>
    )
}

export default HeaderOrgItem
